import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {getCookie} from "../helpers/utils";

@Injectable({
  providedIn: 'root'
})
export class TournamentTunerMethodsService {

  private _availableTournamentGridsURL: string = '/api/v1/tournament_bracket_types/';
  private _apiTournament: string = '/api/tournament/';
  private _actionsDict = {
    grid: 'create_brackets',
    group: 'create_group_only',
    gridAndGroups: 'create_groups_with_brackets',
  }

  private _tournamentGridRequired: boolean = false;
  private _groupsAmount: number;
  private _playersLeavingGroupNumber: number;
  private _tournamentId: number;
  private _thirdPlaceTournamentAvailable: boolean = false;

  private _tournamentTypeDict: availableTournaments = {
    withGroups: 'withGroups',
    conventional: 'conventional',
  };

  private _checkBoxLabels: checkboxLabels = {
    withGroups: 'Группы',
    conventional: 'Сетка'
  }

  private _requestsList = {
    conventional: this.createGridOfCertainType.bind(this),
    withGroups:  this.createGroupsWithGridOfCertainType.bind(this)
  }

  private _argsForGrid = {
    conventional: [
      this.tournamentId,
    ],
    withGroups: [
      this.tournamentId,
      this.playersLeavingGroupNumber,
      this.groupsAmount,
    ]
  }

  private _chosenTournamentType: string;
  private _enableConventionalGridTypesList: boolean = false;
  private _playersAmount: number;

  constructor(
    private http: HttpClient
  ) { }

  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }

  certainTournamentGridTypesListURL(tournamentId, playersLeavingGroups, groupsAmount): string {
    return playersLeavingGroups > 0 && groupsAmount > 0
      ?`${this._availableTournamentGridsURL}${tournamentId}/?groups_out_count=${playersLeavingGroups}&groups_count=${groupsAmount}`
      : `${this._availableTournamentGridsURL}${tournamentId}`;
  }

  getAvailableGridTypesList(tournamentId, playersLeavingGroups = -1, groupsAmount = -1) {
    return this.http.get(
      this.certainTournamentGridTypesListURL(tournamentId, playersLeavingGroups, groupsAmount),
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        }
      }
    );
  }

  createTournamentEssence(action: string, tournamentId: number, body = {}) {
    return this.http.post(
      `${this._apiTournament}${tournamentId}/players`,
      {
        action: action,
        ...body
      },
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        }
      }
    );
  }

  createGridOfCertainType(gridType: string, tournamentId: number) {
    return this.createTournamentEssence(
      this._actionsDict.grid,
      this.tournamentId,
      {
        bracket_type: gridType,
        need_3rd_place_match: this.thirdPlaceTournamentAvailable,
      },
    );
  }

  createGroupOnly(tournamentId: number) {
    return this.createTournamentEssence(
      this._actionsDict.group,
      tournamentId,
    );
  }

  createGroupsWithGridOfCertainType(
    gridType: string,
    tournamentId: number,
    playersLeavingGroup: number,
    groupsAmount: number,
  ) {
    return this.createTournamentEssence(
      this._actionsDict.gridAndGroups,
      this.tournamentId,
      {
        groups_out_count: this.playersLeavingGroupNumber,
        groups_count: this.groupsAmount,
        bracket_type: gridType,
        need_3rd_place_match: this.thirdPlaceTournamentAvailable,
      }
    );
  }

  gridTypeClickHandler(gridType: string) {
    return this._requestsList[this.chosenTournamentType](gridType, ...this._argsForGrid[this.chosenTournamentType]);
  }

  createGroupOnlyClickHandler() {
    return this.createGroupOnly(this.tournamentId);
  }


  get tournamentTypeDict(): availableTournaments {
    return this._tournamentTypeDict;
  }

  get chosenTournamentType() : string {
    return this._chosenTournamentType;
  }

  set chosenTournamentType(value) {
    this._chosenTournamentType = value;
  }

  isConventional(): boolean {
    return this.chosenTournamentType === this._tournamentTypeDict.conventional;
  }

  get groupsAmount() :number {
    return this._groupsAmount;
  }

  set groupsAmount(value) {
    this._groupsAmount = value;
  }

  get playersLeavingGroupNumber(): number {
    return this._playersLeavingGroupNumber;
  }

  set playersLeavingGroupNumber(value) {
    this._playersLeavingGroupNumber = value;
  }

  get tournamentId(): number{
    return this._tournamentId;
  }

  set tournamentId(value) {
    this._tournamentId = value;
  }

  get checkBoxLabels(): checkboxLabels {
    return this._checkBoxLabels;
  }

  get tournamentGridRequired(): boolean {
    return this._tournamentGridRequired;
  }

  set tournamentGridRequired(value) {
    this._tournamentGridRequired = value;
  }

  get enableConventionalGridTypesList() :boolean {
    return this._enableConventionalGridTypesList;
  }

  set enableConventionalGridTypesList(value) {
    this._enableConventionalGridTypesList = value;
  }

  get playersAmount(): number {
    return this._playersAmount;
  }

  set playersAmount(value) {
    this._playersAmount = value;
  }

  get thirdPlaceTournamentAvailable(): boolean {
    return this._thirdPlaceTournamentAvailable;
  }

  set thirdPlaceTournamentAvailable(value: boolean) {
    this._thirdPlaceTournamentAvailable = value;
  }
}

export interface checkboxLabels {
  withGroups: string,
  conventional: string,
}

export interface availableGridTypesResponse {
  enable_bracket_types: string[],
  max_player_count: number,
}

export interface availableTournaments {
  withGroups: string,
  conventional: string,
}
